module.exports = __webpack_public_path__ + "img/unitednations.cf069346.svg";